/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type GetCreditAnalyticsParams = {
days?: number | null;
/**
 * @maxLength 64
 */
tz?: string;
categories?: string[];
entry_types?: string[];
actor_user_ids?: string[];
exclude_categories?: string[];
exclude_entry_types?: string[];
exclude_actor_user_ids?: string[];
occurred_from?: string | null;
occurred_to?: string | null;
direction?: string | null;
};
